import React from 'react';
import PropTypes from "prop-types";
import { Row, Col, Tooltip } from 'antd';
import RecurringIcon from "../../../../../../../assets/icons/recurring.svg";
import GaIcon from "../../../../../../../assets/icons/grant-agreement.svg";
import { DisplayFlex } from "../../../../../../../CommonComponents/commonStyles";
import { ModelDataHeading, UnderlineLinkBold, PopupContentDivider } from '../style';
import { LabelDataHeading, ValueDataHeading } from '../../../style';
import { formatAmount } from "../../../../../../../utils/commonUtil";

export const renderSpawnType = (data) => {
  if (data.isRecurring) {
    return (
      <Tooltip placement="bottomLeft" title="Recurring Grant Schedule" trigger="click">
        <img className="pointer" src={RecurringIcon} alt="recurring grant" />
      </Tooltip>
    );
  } else if (data.grantAgreement) {
    return (
      <Tooltip placement="bottomLeft" title="Grant Agreement" trigger="click">
        <img className="pointer" src={GaIcon} alt="grant agreement" />
      </Tooltip>
    );
  }
}

export default function PopupCard({ data, type, grantDetailsHandler }) {
  return (
    <div>
      <Row>
        <Col span={22}>
          <DisplayFlex>
            <ModelDataHeading>Transaction ID:</ModelDataHeading>
            {data.grantAgreement 
              ? <ModelDataHeading>{data.transactionId}</ModelDataHeading>
              : <UnderlineLinkBold data-test="popup-card-click" onClick={() => grantDetailsHandler(data.transactionId, "single")}>{data.transactionId}</UnderlineLinkBold>
            }
          </DisplayFlex>
        </Col>
        <Col span={2}>
          {renderSpawnType(data)}
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <LabelDataHeading>{type === "history" ? "Issued Date" : "Entered Date"}</LabelDataHeading>
          <ValueDataHeading>{data.receiveDate}</ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Amount</LabelDataHeading>
          <ValueDataHeading>{formatAmount(data.grantAmount)}</ValueDataHeading>
        </Col>
      </Row>
      <PopupContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>Purpose</LabelDataHeading>
          <ValueDataHeading>{data.grantPurpose}</ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Recognition</LabelDataHeading>
          <ValueDataHeading>{data.grantRecognition}</ValueDataHeading>
        </Col>
      </Row>
      {type === "pending" && (
        <>
          <PopupContentDivider />
          <Row>
            <Col span={12}>
              <LabelDataHeading>Status</LabelDataHeading>
              <ValueDataHeading>{data.status}</ValueDataHeading>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

PopupCard.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
  grantDetailsHandler: PropTypes.func
}
